import { Component, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

/** Listenin geçerli sıralaması; `sortBy` boşsa sunucunun varsayılan sırası. */
export interface ListSort {
  sortBy: string | null;
  sortDescending: boolean;
}

export const DEFAULT_LIST_SORT: ListSort = { sortBy: null, sortDescending: false };

/**
 * Sıralanabilir tablo başlığı:
 * `<th appSortHeader="issueDate" [sort]="sort" (sortChange)="onSort($event)">Tarih</th>`
 *
 * Tıklama sırası artan → azalan → varsayılan. Sıralama sunucuda yapılıyor:
 * listeler sayfalı, istemcide sıralamak yalnızca ekrandaki sayfayı dizerdi.
 */
@Component({
  selector: 'th[appSortHeader]',
  template: `
    <span class="sort-header">
      <ng-content></ng-content>
      <i class="bx sort-header__icon" [ngClass]="icon" aria-hidden="true"></i>
    </span>
  `,
  styles: [`
    :host { cursor: pointer; user-select: none; white-space: nowrap; }
    .sort-header { display: inline-flex; align-items: center; gap: .25rem; }
    .sort-header__icon { font-size: 1rem; opacity: .35; transition: opacity .15s; }
    :host(:hover) .sort-header__icon { opacity: .7; }
    :host(.is-sorted) .sort-header__icon { opacity: 1; }
  `],
})
export class SortHeaderComponent {
  @Input('appSortHeader') key!: string;
  @Input() sort: ListSort | null = null;
  @Output() sortChange = new EventEmitter<ListSort>();

  @HostBinding('attr.tabindex') readonly tabindex = 0;

  @HostBinding('class.is-sorted')
  get active(): boolean {
    return !!this.key && this.sort?.sortBy === this.key;
  }

  @HostBinding('attr.aria-sort')
  get ariaSort(): string {
    if (!this.active) return 'none';
    return this.sort!.sortDescending ? 'descending' : 'ascending';
  }

  get icon(): string {
    if (!this.active) return 'bx-sort-alt-2';
    return this.sort!.sortDescending ? 'bx-sort-down' : 'bx-sort-up';
  }

  @HostListener('click')
  @HostListener('keydown.enter')
  toggle(): void {
    if (!this.active) {
      this.sortChange.emit({ sortBy: this.key, sortDescending: false });
    } else if (!this.sort!.sortDescending) {
      this.sortChange.emit({ sortBy: this.key, sortDescending: true });
    } else {
      this.sortChange.emit({ ...DEFAULT_LIST_SORT });
    }
  }
}
